import { CacheStoragesEnum } from './cache.models';

export class CacheConfiguration extends Array<CacheStoragesEnum> {}
